/* 
  Welcome to the custom js section 
  This code does not belong to the theme.
  This code is written by Yours Truly. 
*/

// // Helper Functions
function removeDollarSign(str) {
    return parseFloat(str.replace(/[^0-9.]/g, ""));
}

function addDollarSign(num) {
    return `$${num}`;
}

// window.addEventListener('load', function () {
//     document.querySelector('.product-form__buttons button.product-form__submit').classList.remove("disabled");
//     document.querySelector('.product-form__buttons button.product-form__submit').disabled = false;;
// })

window.addEventListener('load', function () {
    var submitBtn = document.querySelector('.product-form__buttons button.product-form__submit');
    if (submitBtn) {
        submitBtn.classList.remove("disabled");
        submitBtn.disabled = false;
    }
})

document.addEventListener('DOMContentLoaded', function () {

    const makeThePaymentBlack = (paymentTermsText) => {
        if (paymentTermsText?.shadowRoot) {
            const elements = [
                paymentTermsText.shadowRoot.querySelector('#shopify-installments'),
                paymentTermsText.shadowRoot.querySelector('#shopify-installments .align-middle')
            ];
            elements.forEach(el => el && (el.style.color = 'black'));
        }
    };

    window.addEventListener('load', function () {
        var event = new Event('change');
        setTimeout(() => {
            document.querySelector('input[value="Upload Additional Artwork [+$5.00 Per Item]"][type="checkbox"]').disabled = true
            document.querySelector('input[value="Upload Additional Artwork [+$5.00 Per Item]"][type="checkbox"]').checked = false
            document.querySelector('input[value="Upload Additional Artwork [+$5.00 Per Item]"][type="checkbox"]').dispatchEvent(event)
            // variantRadios.dispatchEvent(event);
        }, 900);
        const decorationTypes = document.querySelector(".cl-po--option");
        if (decorationTypes) {
            decorationTypes.addEventListener("change", function () {
                var event = new Event('change');
                const selectedType = document.querySelector(".cl-po--radio-item input[type='radio']:checked")
                if (selectedType.value.toLocaleLowerCase() !== "sample") {
                    document.querySelector('input[value="Upload Additional Artwork [+$5.00 Per Item]"][type="checkbox"]').disabled = false
                    document.querySelector('.cl-po--option[data-option="Attached Artwork"]')
                    document.querySelector('.cl-po--option[data-option="Attached Artwork"]').style.display = 'block'
                    document.querySelector('.cl-po--option[data-option="Decoration Location"]').style.display = 'block'
                } else {
                    document.querySelector('input[value="Upload Additional Artwork [+$5.00 Per Item]"][type="checkbox"]').disabled = true
                    document.querySelector('input[value="Upload Additional Artwork [+$5.00 Per Item]"][type="checkbox"]').checked = false
                    document.querySelector('input[value="Upload Additional Artwork [+$5.00 Per Item]"][type="checkbox"]').dispatchEvent(event)
                    document.querySelector('.cl-po--option[data-option="Attached Artwork"] span.cl-po--remove')?.click()
                    setTimeout(() => {
                        document.querySelector('.cl-po--option[data-option="Decoration Location"] input').value = '';
                    }, 700);
                    document.querySelector('.cl-po--option[data-option="Attached Artwork"]').style.display = 'none'
                    document.querySelector('.cl-po--option[data-option="Decoration Location"]').style.display = 'none'
                }
            });
        }
    })

    const quantityObserver = new MutationObserver(() => {
        makeThePaymentBlack(document.querySelector('shopify-payment-terms'));
    });

    if (document.querySelector(".product-form__quantity")) {
        quantityObserver.observe(document.querySelector(".product-form__quantity"), {
            attributes: true,
            childList: true,
            subtree: true
        });
    }
});

